import { AppRouting } from '../shared/constants';
import { NavigationPanelRoutes } from '../user-management/user-management.const';
import { AccessControlRoutes } from '../access-control/acces-control.consts';
import { NavMenu } from './model';

export const menuItems: NavMenu[] = [
  {
    id: `/${AppRouting.USER_MANAGEMENT}`,
    label: 'User management',
    icon: 'users',
    isExpanded: false,
    root: true,
    children: [
      {
        id: `/${AppRouting.USER_MANAGEMENT}/${NavigationPanelRoutes.PENDING}`,
        label: 'Pending Users',
        isExpanded: false,
      },
      {
        id: `/${AppRouting.USER_MANAGEMENT}/${NavigationPanelRoutes.ACTIVE}`,
        label: 'Active Users',
        isExpanded: false,
      },
      // {
      //   id: `/${AppRouting.USER_MANAGEMENT}/${NavigationPanelRoutes.BLOCKED}`,
      //   label: 'Rejected Users',
      //   isExpanded: false,
      // }
    ]
  }, {
    id: `/${AppRouting.ACCESS_CONTROL}`,
    label: 'Access control',
    icon: 'settings',
    isExpanded: false,
    root: true,
    children: [
      {
        id: `/${AppRouting.ACCESS_CONTROL}/${AccessControlRoutes.ROLE_MANAGEMENT}`,
        label: 'Role management',
        isExpanded: false,
      },
      {
        id: `/${AppRouting.ACCESS_CONTROL}/${AccessControlRoutes.RIGHTS_MANAGEMENT}`,
        label: 'Rights management',
        isExpanded: false,
      },
    ]
  }
];
